import { render } from "./CompaniesActions.vue?vue&type=template&id=6633fe59"
import script from "./CompaniesActions.vue?vue&type=script&lang=js"
export * from "./CompaniesActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__